import type { PurchaseOrderStatus } from "@/features/purchase/types";

export const PO_STATUSES: { value: PurchaseOrderStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: "confirmed", label: "Confirmed" },
  { value: "partial", label: "Partial" },
  { value: "closed", label: "Closed" },
  { value: "cancelled", label: "Cancelled" },
];

export function labelFor(
  options: { value: string; label: string }[],
  value: string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(
  status: PurchaseOrderStatus,
): "success" | "warning" | "danger" | "neutral" {
  switch (status) {
    case "confirmed":
    case "closed":
      return "success";
    case "sent":
    case "partial":
      return "warning";
    case "cancelled":
      return "danger";
    default:
      return "neutral";
  }
}

/**
 * FY label from a date, e.g. 2026-07-30 with Apr start → 2627.
 * @param startMonth 1=Jan … 4=Apr (default Indian FY)
 */
export function fiscalYearLabel(date: Date | string, startMonth = 4): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const y = d.getFullYear();
  const m = d.getMonth() + 1; // 1-based
  const start = m >= startMonth ? y : y - 1;
  const end = (start + 1) % 100;
  return `${String(start).slice(-2)}${String(end).padStart(2, "0")}`;
}

export function canEditLines(status: PurchaseOrderStatus) {
  return status === "draft";
}

export function canEditHeader(status: PurchaseOrderStatus) {
  return status === "draft" || status === "sent" || status === "confirmed";
}

export function canReceive(status: PurchaseOrderStatus) {
  return status === "confirmed" || status === "partial";
}

/** Tolerance when comparing ordered vs received weight */
export const RECEIVE_EPSILON = 0.0001;

export function yymmLabel(date: Date | string = new Date()): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const yy = String(d.getFullYear()).slice(-2);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${yy}${mm}`;
}
